export default "__VITE_ASSET__CeRiqkSx__"